import React from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-background" data-testid="error-boundary">
          <div className="max-w-md w-full text-center rounded-2xl bg-card border border-border p-8">
            <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-destructive/10">
              <AlertTriangle className="h-7 w-7 text-destructive" />
            </span>
            <h1 className="mt-4 font-heading font-extrabold text-xl text-secondary">Une erreur est survenue</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              Quelque chose s'est mal passé. Rechargez la page pour continuer.
            </p>
            <button
              onClick={() => window.location.reload()}
              data-testid="error-boundary-reload"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary px-6 py-2.5 text-sm font-bold text-primary-foreground hover:opacity-90 transition-opacity"
            >
              <RotateCcw className="h-4 w-4" /> Recharger la page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
